import React from "react";
import "./index.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Section from "./components/Section";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function App() {
  const emailHTML = `<a href="mailto:kai@alltruebites.com">Reach out via email</a>`;
  return (
    <>
      <Navbar />
      <Hero />
      <Section
        id="vision"
        title="Our Vision"
        img="/images/yoga.jpg"
        content="We envision a world where doing good—for yourself, for others, and for the planet—is second nature. Through thoughtful nutrition and unselfish intention, Alltru aims to spark a movement of everyday altruism, where even the smallest choices can lead to a healthier, more connected world." 
        content_2 = "In the fast-paced tech world, friends Ali and Kai shared more than demanding careers—they shared a mission to live healthier lives for themselves and their families. As fathers, they struggled to find nutritious snacks amid long workdays and unhealthy food options. Weekend escapes into nature inspired them to seek better alternatives to the processed, sugar packed products on the market. In the world packed with process food and lack of wholesome protein snacks, they envisioned something different: clean, meat snacks made from grass-fed, humanely raised sources. alltruebites was born from this vision."
        styleClass="section vision"
      />
      <Section
        id="about us"
        title="Ilkay Darilmaz"
        img="/images/kai-profile.jpg"
        content="Co-Founder"
        content_2="Ilkay graduated from Massachsetts Institute of Technology (MIT) with advanced engineering degrees in 2008. Since then, he worked for enterprise engineering firms and tech corporations. Albeit busy schedule, Kai did not sacrifice on healthy living lifestyle. His focus on training and nutrition, sparked him to find healthy snacks that doesnt give up on flavor and yet offer good for you and indulgent alternatives. He wanted to create on the go snacks that are alternative to processed foods packed with chemicals and preservatives."
        styleClass="section bio-top"
      />

      <Section
        id="about us ali"
        title="Ali Zagros"
        content="Co-Founder"
        content_2="Ali is a seasoned technology specialist with a long-standing career in IT, but his true motivation lies in living a purposeful, balanced life. He believes in making every moment count—whether it’s creating lasting memories with family or pursuing personal interests. Outside of work, Ali stays active through yoga, Brazilian jiu-jitsu, and amateur automotive racing. His passion for wellness and performance inspired him to co-found AllTrueBites, a brand born from his desire to create a nutritious snack that fuels both body and ambition."
        img="/images/ali-profile.jpg"
        styleClass="section bio"
      />

      <Section
        id="products"
        title="Products"
        img="/images/product.png"
        content="We're actively researching and developing new products, starting with what your mind and body truly need and working backward to create products that can be sustainably produced. Stay tuned—we're excited to bring these innovations to life soon."
        styleClass="products"
      />

      <Section
        id="charities"
        title="Charities"
        img="/images/charities.avif"
        content="At the heart of our brand is a commitment to doing better—better for our consumers, better for the environment, and better for our communities. That’s why we back our values with action, dedicating 10% of our net proceeds to charitable causes. Even more, we invite our customers to help shape the impact by choosing the causes that matter most to them."
        content_2="We value transparency, which is why we will publish quarterly reports detailing the proceeds directed to charitable initiatives and share how our community is making a difference—one purchase at a time."
        styleClass="charities"
      />

      <Section
        id="contact"
        title="Keep in Touch"
        img="/images/connect.avif"
        content="We'd love to hear from you! Follow us on social or reach out via email..."
        content_2= {emailHTML}
        content2Class="hero-btn"
        styleClass="connect"
      />
    </>
  );
}

export default App;
